import { mediaMax } from '@/app/styles/breakpoints'
import { Flex } from 'antd'
import styled from 'styled-components'

export const AccountsGridList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  width: 100%;

  ${mediaMax.xl} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${mediaMax.lg} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaMax.md} {
    grid-template-columns: 1fr;
  }
`

export const AccountsGridVirtualContainer = styled.div`
  height: 664px;
  width: 100%;

  .ReactVirtualized__Grid {
    overflow: hidden !important;
  }
`

export const PaginationContainer = styled(Flex)`
  && {
    .ant-pagination-prev,
    .ant-pagination-next {
      padding: 0 12px;
    }
    svg {
      fill: currentColor;
    }
    .ant-pagination-disabled {
      opacity: 0.25;
    }
    li:not(.ant-pagination-disabled) {
      color: ${(props) => props.theme.colors.primary};
    }
    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.colors.primary};
      a {
        color: white;
      }
    }
    .ant-pagination-item:not(.ant-pagination-item-active) {
      ${mediaMax.sm} {
        display: none;
      }
    }
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next + .ant-pagination-item {
      ${mediaMax.md} {
        display: none;
      }
    }
  }
`

export const PagerButton = styled(Flex)``
